module.exports = __webpack_public_path__ + "media/application/images/svgs/corner-left-down-79bc4883d9a86d1d595c99c0a54679de.svg";